import React, { FC } from 'react'
import { Spin, Typography, Card, Space, Row } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { AttachmentList } from '../../../Shared/FileUploader/AttachmentList'
import { AttachmentRecord } from '../../../Shared/FileUploader/types'
import { Requests, ReactQuery } from 'api'
import { MESSAGES } from '../constants'
import { handleDownload } from '../helpers'
import styles from '../styles.module.scss'

export const Scanbacks: FC<{ orderId: number }> = ({ orderId }) => {
  const attachmentsRequest = Requests.attachments({ orderId })
  const { data, isLoading } = useQuery({
    queryKey: [attachmentsRequest.type, orderId],
    queryFn: () => ReactQuery.fetchResources(attachmentsRequest)
  })

  const scanbacks = (data?.resources ?? []).filter((a: AttachmentRecord) => a.uploadedByNotary)

  if (!isLoading && scanbacks.length === 0) return null

  return (
    <Card>
      <Space>
        <Typography.Text type="secondary">
          <FileTextOutlined className={styles.headerIcon} />
        </Typography.Text>
        <Typography.Title level={4}>{MESSAGES.SCANBACK_DOCUMENTS_TITLE}</Typography.Title>
      </Space>
      {isLoading ? (
        <Row justify="center">
          <Spin />
        </Row>
      ) : (
        <AttachmentList
          attachments={scanbacks}
          title={MESSAGES.SCANBACK_ATTACHMENT_LIST_TITLE}
          onDownload={(attachment) => handleDownload(attachment, orderId)}
        />
      )}
    </Card>
  )
}
